import * as React from "react"
import {SaveResetButtons, SectionProps, UpdatableFormSection} from "./UpdateBookingWizard"
import {Form} from "semantic-ui-react"
import {BookingNotesField} from "./BookingDetails"
import {GraphQL} from "../graphql"
import {SetBookingNotes} from "../graphql/queries"
import {errorUnionToEither} from "../graphql/errors"

interface NotesState {
  notes: string
}

export function NotesSection(props: SectionProps) {
  const state: NotesState = {
    notes: props.booking.notes,
  }
  return (
    <UpdatableFormSection
      {...props}
      state={state}
      header="Booking Notes"
      render={(params) => {
        const {state, mapState} = params
        return (
          <Form>
            <Form.Field>
              <BookingNotesField
                {...props}
                notes={state.notes}
                onNotes={
                  mapState &&
                  ((notes) => {
                    mapState((state) => ({notes}))
                  })
                }
              />
            </Form.Field>
            {mapState && (
              <Form.Group>
                <SaveResetButtons
                  {...props}
                  onSave={async () => {
                    const data = await props.modalStore.applyModal({
                      pending: ["Saving booking notes", "Saving booking notes.."],
                      error: (m) => ["Failed to save booking notes", m],
                      action: async () => {
                        const data = await GraphQL.mutate(SetBookingNotes, {
                          id: props.booking.id,
                          notes: state.notes,
                        })
                        return errorUnionToEither(data.setBookingNotes)
                      },
                    })
                    return data.isRight()
                  }}
                />
              </Form.Group>
            )}
          </Form>
        )
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/BookingNotesSection.tsx